import React from 'react';
import { Box } from '@mui/material';

import RoomDetail from '../RoomDetail';
import RoomUserDetail from '../RoomUserDetail';

function RoomDetailWithUserDetail({
  event,
  masterTags,
  round,
  updateMasterTags,
  user,
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: 'minmax(0, 2fr) minmax(320px, 1fr)',
        },
        alignItems: 'stretch',
        gap: '16px',
        width: 'min(100%, 1360px)',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <RoomDetail
          user={user}
          event={event}
          round={round}
          masterTags={masterTags}
          updateMasterTags={updateMasterTags}
        />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <RoomUserDetail user={user} />
      </Box>
    </Box>
  );
}

export default RoomDetailWithUserDetail;
